module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_c('strong', [_vm._v("THE “JEW BROKER” IN AMERICAN CULTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What we know about pawnbrokers comes primarily from popular culture. Television crime dramas show them fencing stolen goods. Newspaper and magazine articles describe how they thrive in floundering economies. And movies portray them as callous and detached, perhaps no more famously than in Sidney Lumet’s screen adaptation of Edward Lewis Wallant’s 1961 novel "), _c('em', [_vm._v("The Pawnbroker.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although delivered through modern media, these stereotypes are part of a much longer tradition. As early as the 1760s—long before there were professional pawnbrokers in the country—Americans were presented with broad characterizations of them, typically elaborations on Shakespeare’s Shylock. Tracing the origins and development of the pawnbroker’s stereotypical qualities, however distorted, is essential to understanding the particular and paradoxical role they played within emerging industrial capitalism. Pawnbrokers were at once necessary to the continued well-being of this economic system and important scapegoats for the various social ills that attended the financial difficulties it brought. Loans from pawnshops supplemented substandard wages, enabling workers to continue to feed their families and producers to continue to exploit their workers. Although capitalists indirectly benefited from the services pawnbrokers provided, it was also in their interest to encourage the idea that pawnbrokers were fringe operators whose business had no place in the “mainstream” economic system. Depicting pawnbroking as aberrant and marginal made wholesale and retail exchange seem “normal” by comparison. So entrenched are stereotypes about pawnbrokers that we continue to internalize them. Even a seasoned historian who had never encountered a pawnbroker once asked me why I wanted "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("to write a book about “those scumbags.” Today’s “scumbags” descended from pawnbrokers formerly identified as “N. Pinch,” “Shylock Graspall,” and simply “the Jew broker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to promote the benefits of capitalism to the general public, businessmen and cultural commentators demonized pawnbroking by portraying it again and again as anathema to the emerging capitalist system. Anti-Semitic characterizations figured largely in this endeavor, defining pawnbrokers as threatening foreigners who looked strange, spoke an alien, barely intelligible dialect, and adopted shady or illegal business practices such as usury and fencing. Their profits never came from hard work or entrepreneurship, unlike those of most wholesalers and retailers. Not only were they were supposedly hard-hearted and greedy, but they supported their customers’ profligacy, intemperance, and criminal inclinations.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("These stereotypes calcified over the long nineteenth century but started surfacing in America in the eighteenth, borrowed from English popular culture. Early print sources became the first references American readers could draw on regarding the character of the pawnbroker (unless, of course, they had been pawners in the Old World). Printers often included humorous squibs in their almanacs, newspapers, and ephemeral pamphlets, including deprecating pieces about pawnbrokers. For example, the London publication "), _c('em', [_vm._v("Mother Midnight’s Comical Pocket-Book,")]), _vm._v(" reprinted in Boston in 1763 for a domestic readership, contained “My Pawnbroker’s "), _c('em', [_vm._v("Epitaph,”")]), _vm._v(" which described the interred as")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("A composition of deceit")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("A thief—a lyar—and a cheat;")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Who ne’er was easy, but when doing")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Something to help poor peoples ruin;")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Such were the fruits of Holdfast’s labour,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("To plunder, rob, and strip his neighbor;")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("He’d let ’em pawn their cloaths and rings,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("And swear he never had such things;")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("He’d sell their rings, he’d wear their cloaths")]), _vm._v(" "), _c('p', {
    staticClass: "poemlineb"
  }, [_vm._v("Himself—or lend ’em out to beaux."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Another “Epitaph on a Pawnbroker” appeared in a 1790 issue of the "), _c('em', [_vm._v("New-York Daily Gazette:")])]), _vm._v(" "), _c('p', {
    staticClass: "poemlinet"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BENEATH")]), _vm._v(" this stone the vile remains are lain,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Of "), _c('em', [_vm._v("Gripus Grasp all Pinch,")]), _vm._v(" a rogue in grain,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Whose studies center’d in the hoard of gain.")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Of needy indigence, for sums he’d lent,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("The usurer extorted cent. per cent.")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Yet wealth beheld him stranger to content.")]), _vm._v(" "), _c('p', {
    staticClass: "poemlinet"
  }, [_vm._v("Death, in his journey passing by that way,")]), _vm._v(" "), _c('p', {
    staticClass: "poemline"
  }, [_vm._v("Took him and pawn’d him to Old Nick one day,")]), _vm._v(" "), _c('p', {
    staticClass: "poemlineb"
  }, [_vm._v("Where other scoundrels like bad pledges lay."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("These and similar space fillers were suggestive, and their themes continued to reverberate over time. The pawnbroker cheated his customers by robbing them of their hard-earned property, appropriating others’ possessions for his own use. He was innately greedy, his “hoard of gain” a compulsion. He was forever in search of more profit, merely as an end in itself. Readers could only hope that, as suggested in the third verse, pawnbrokers would get what was coming to them in the afterlife, their souls pawned to the devil like so many pieces of worthless collateral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On stage, Shylock appeared in Shakespeare’s "), _c('em', [_vm._v("Merchant of Venice,")]), _vm._v(" undoubtedly the most famous and notorious Jewish character. Premiering in America in 1752 in Williamsburg, Virginia, the play helped disseminate “significant cultural baggage” about European Jews to Americans up and down the East Coast, from Albany to Charleston."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Shylock could easily be seen as symbolizing all Jews as unprincipled and godless. Their blind devotion to money might even drive them to mutilate and murder their own."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The unflattering depictions of Jewish moneylenders in popular culture were expressions of real and increasing anxieties about issues ranging from immigration and class status to legitimate employment and the morality of profit making. In 1782 financier and one-time treasurer of the United States Robert Morris wrote to a friend about the unusually high interest rates charged on cash loans during the Revolution, referencing Jewish moneylenders. “Mortifying as it is,” he wrote, “the Jew Brokers and others have informed me in the course of my inquiries that "), _c('em', [_vm._v("Sub Rosa")]), _vm._v(" they frequently get 5 per Cent per month from good Substantial men for the use of Money with pledges lodged for the repayment.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Morris’s use of “Jew broker” was likely meant to be descriptive rather than pejorative."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" The moneylenders he referred to, members of an elite group, helped Morris broker deals with the French to finance the war, since the fledgling nation had no resources of its own. They were respected for their connections and resources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet Morris’s view of the “Jew broker” as a respectable figure remained a minority opinion. Most Americans had no firsthand experience with Jews (there were only about five thousand in the country in the 1820s) and therefore "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("impressions—“Jews-in-the-abstract”—came from caricatures imported from across the Atlantic."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Shylock was one referent. Physical characteristics, including facial features and clothing, which would be increasingly exaggerated, were another. Early cartoonists’ signifiers for Jews included large, hooked noses, wide hands with open palms, and what would become their recognized symbol—the sign of the three balls."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" As the eighteenth century moved to the nineteenth, and again as the nineteenth century turned to the twentieth, the pawnbroker emerged as a prominent figure whose popular characterization was reshaped and redeployed to suit contemporary needs, embodying prevailing concerns as they changed over time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pawnbroker became a cultural figure who conveniently embodied marginal status both socially and economically. He was portrayed as a Jew, a member of a religious minority. And he came with the European legacy of being engaged in a bad business. It was a gift to propagandists that each of these generalizations, like all stereotypes, had some basis in truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Depictions of pawnbrokers in popular culture, whether in fictional or supposedly nonfictional accounts, were as a rule anti-Semitic. In the first decades of the nineteenth century Americans accepted as fact that moneylending and usury were Jewish practices. In short order people conflated ethnic or religious affiliations with unscrupulous economic practices, thus forging conceptual links between Jews, usury, and pawnbroking that prevail even today. Nineteenth-century stereotypes painted the Irish as ignorant drunks, African Americans as lazy pilferers, and Jews as greedy connivers. This was a marked change from the respect Robert Morris gave to the “Jew brokers” he dealt with just a few decades earlier. Increasingly, a pawnbroker’s Jewishness, real or perceived, determined the way he was portrayed and what he symbolized. To the nativists he was a foreigner taking money from hardworking Americans. To racists he was a strange-looking figure whose habits were alien, mysterious, and threatening. To social reformers he was both the supplier of money for alcohol that led people to intemperance and someone who took away people’s cherished possessions. And to fellow businessmen he was a rival who tended to trade among his own kind (perhaps more profitably, too). Many Americans felt “ambivalence” toward Jews, whom they considered enterprising yet opportunistic. Jews could be seen as displaying “an admirable keenness and resourcefulness in business,” yet “keenness might mean cunning; enterprise might shade into greed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Articulated as “questions” and “concerns,” ideas about Jews remained relatively unformed at the beginning of the nineteenth century, although the specter of Shylock continued to influence people’s general perceptions. “Queries respecting the Jews” frequently appeared in American magazines and newspapers. "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("The writers wondered who Jews were, where they came from, and what they did. The Jews living in America at the time were still so few—and concentrated in the urban areas of the East Coast—that their habits and general character (assuming there was such a thing) were still mysterious and inscrutable to the predominantly Christian populace. The population of the United States increased from 3.9 million to 9.6 million between 1789 and 1839. The Jewish subpopulation (still less than 1% of the total) grew even faster, from about 1,350 people in 1790 to 15,000 in 1840. Outside the major cities on the eastern seaboard, though, Jews remained “only dots in a Protestant landscape.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people’s experience with Jews was mediated through popular literature, folk culture, and religious teachings, creating a disconnect between common perceptions (often misconceptions) of Jews collectively and individually. There was the “mythical Jew,” who was looked on with suspicion, and the “Jew who was known,” who was well regarded."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Americans remained uncertain about which Jews they might encounter and whether to welcome or fear them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" In one instance a reader calling himself “Biblicus” asked the editor of the "), _c('em', [_vm._v("Monthly Magazine, and American Review")]), _vm._v(" in 1800 “to obtain information concerning several points in the history and present state of the Jews.” He continued, “Every believer in [C]hristianity must look upon that people with peculiar respect and attachment, when he recollects how intimately their selection and separation from the rest of the world and their future prospects, are connected with the religion which he professes.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Other inquisitive readers wanted to know how many Jews currently lived in the world and where; if they had a governing body and if so, how it was structured; whether they still had distinct “tribes”; and if any lineal descendants of David were still alive. In a subsequent issue of the "), _c('em', [_vm._v("Monthly Magazine,")]), _vm._v(" “Querist” asked a most elemental question “of no small importance”: “What is a Jew?” The self-described “rational Christian” answered his own question, disavowing Judaism altogether. “In embracing [C]hristianity, the rational man believes that he is fulfilling the law and the prophets, and is conforming strictly to the directions of Jehovah and his servant Moses. But admitting that the creed of a proper Jew must "), _c('em', [_vm._v("exclude")]), _vm._v(" a belief in Christ, that negative alone does not make a Jew.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" If Jewishness was a matter of lineage, the writer reasoned, then “it is impossible to ascertain the genuineness of a Jew.” He asked plaintively, “If an indefinite pedigree be not necessary to make a Jew, what number of generations must pass before he acquires all the penalties and privileges annexed to his people? Are they five, ten, fifteen, or twenty generations?” And finally, “Where is to be found the tree of any Jew’s pedigree?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Jews’ affiliation with pawnbroking and related trades, such as dealing in used clothes and auctioneering, created among them a cohesive, commercially defined "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("group; yet it also reinscribed outsiders’ perceptions that they operated beyond the currents of mainstream trade. In the second decade of the nineteenth century the public was still trying to determine whether the “Jewishness” of such businesses should be cause for concern. Take this exchange between two rival New York City newspapers from 1817. On August 25 the "), _c('em', [_vm._v("New York Evening Post")]), _vm._v(" published a brief court report:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("J. Sommers, a Jew Pawn-Broker, in Chatham-street, was convicted and fined on Friday last, one hundred dollars, at the suit of the Mayor and Corporation of the city of New-York, for having charged on goods pawned with him at the rate of about 65 per cent per annum, instead of seven as allowed by law."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("The next day the "), _c('em', [_vm._v("National Advocate")]), _vm._v(" reprinted the report, for two reasons:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("First, in order to inform our readers that an extortioner has been justly punished; and, secondly, to give them to know . . . that the offender "), _c('em', [_vm._v("is not a Jew.")]), _vm._v(" This is a new and unique mode of attempting to designate men by their "), _c('em', [_vm._v("religious persuasion,")]), _vm._v(" whether for criminal or political offences. . . . This system would be very apt and common in London, or in any part of that country which is so much the object of Mr. Coleman’s admiration and "), _c('em', [_vm._v("imitation;")]), _vm._v(" but he may have yet to know, that in the United States, the Jew is his equal in rights, privileges, talents, and "), _c('em', [_vm._v("almost")]), _vm._v(" his equal, we may say, in "), _c('em', [_vm._v("moral character!")]), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', [_vm._v("New York Evening Post")]), _vm._v(" responded the next day, claiming that the paper was not referring to Sommers’s religion when using the Jew “epithet.” It is used, the paper explained, “in common parlence, however improperly, as synonimous with extortioner.” Before ending the discussion, the paper also pointed out this technicality: “In regard to the religion of Mr. Sommers, it is pretty evident from his unconscionable usury that he is not possessed of any. But he is nevertheless the son of Jewish parents, and though he may not belong to the synagogue, is, in point of fact as well as principle, entitled to the denomination which we bestowed upon him.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Both papers tried to argue the case on its merits—the "), _c('em', [_vm._v("National Advocate")]), _vm._v(" asserted that one’s Jewishness was irrelevant, while the "), _c('em', [_vm._v("Evening Post")]), _vm._v(" countered that “Jew” was popularly understood to be a synonym for usurer and not necessarily indicative of religious affiliation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It mattered little whether or not individual pawnbrokers were Jewish. Because they were all assumed to be, people scrutinized pawnbrokers’ business practices and questioned their ethics. Other businessmen objected to Jews’ opening their shops on Sunday, the Christian Sabbath. For example, a menacing notice placed in an 1828 issue of the "), _c('em', [_vm._v("New York Flagellator")]), _vm._v(" called out one such operator: “Had not a certain "), _c('em', [_vm._v("little")]), _vm._v(" Pawnbroker in Chatham-street, better make up his mind whether "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("he is Jew or Christian, and not keep open house both days [Saturday and Sunday]? We shall expose him if he does not mend [his ways].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Critics argued that doing business on Sunday, a holy day, was an affront to Christians and a transgression against the accepted rules of commerce. But concerns likely also arose because Jews could make money on days when Christian merchants could not. (Jewish proprietors opened their pawnshops at sundown on Saturdays and did brisk business well into the night.) Economic and cultural insecurities together fomented anti-Semitic sentiment. Any profits made by Jews, “the medieval symbol of Mammon,” were characterized as ill-gotten gains, a charge that allowed merchants and manufacturers (who underscored their Christian principles) to deflect criticism from their own profitable yet exploitative business practices."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time and again people claimed to be tolerant and open-minded. Yet they resorted to epithets and stereotypes when addressing matters of profit and loss. For example, a writer in an 1841 issue of the "), _c('em', [_vm._v("Sunday Flash")]), _vm._v(" began, “We are friends to toleration . . . and we would put a Jew on the same footing with a Christian.” Yet he objected to the prohibition against newsboys’ selling papers on Sundays “while a swarm of blackguard, ugly Israelites” were allowed to sell used clothing the entire weekend. If the Board of Assistants allowed business to be conducted on Sundays, then “we intend to hire a host of little Hebrews to sell the Flash on Sunday, as it seems to be lawful for them to break the Christian Sabbath.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because Jews tended to enter financial and commercial professions rather than artisanal trades, people associated them with money. At times Jews’ reputed financial acumen worked to their advantage. Throughout the United States Jews experienced some form of legal discrimination in the eighteenth and early nineteenth centuries, and in many states they were barred from voting, holding office, and practicing law. Yet the contribution of Jewish merchants and traders to Maryland’s economy helped realize the passage of the “Jew Bill” in 1826, which accorded them basic suffrage. The state’s need for revenue rather than religious tolerance spurred the decision, because “restricting the vote to Christians not only tended to place limits on those who might contribute to the state’s wealth, but also provided a reason for some Jews to seek other abodes.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" When there was more at stake, such as the welfare of an entire state (or the funding of a Revolution), then anti-Semitism receded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ability to make money—celebrated in such figures as the wealthy banker Stephen Girard—more often proved a liability for Jewish businessmen, who could not escape being seen as nineteenth-century Shylocks, “vastly powerful, manipulative, corrupt, devious, cunning, greedy, tricky, materialistic, dishonest, shrewd, grasping, and close-fisted.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" In addition, any economic success Jews enjoyed was assumed to have derived from crime. Commentators held up Christian "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("merchants as exemplars of honesty and integrity. By that standard Jews (in opposition to Christians) could only be morally corrupt, and their commercial dealings must be highly suspect and unseemly. In 1846, for example, the "), _c('em', [_vm._v("National Police Gazette")]), _vm._v(" responded to criticism regarding an article titled “Crime among the Israelites.” The "), _c('em', [_vm._v("Gazette")]), _vm._v("’s editor admitted that the piece was “calculated to reflect improperly upon the general character of the Israelites of this city.” He continued, “A different impression has been created by those who are not close observers, from the fact that in almost every instance where an Israelite has been arrested for an offence, it is noted in the police reports of our city press, as having been committed by a ‘Jew,’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("” while the religion of other accused criminals was “rarely if ever given.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other supposedly reliable and objective sources reinforced these stereotypes, replacing the image of “the Sephardic merchant princes” with shabby and semi-literate German peddlers “as the prototypical American Jews,” who were by association also “usurious villain[s].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" For example, Ben Israel Tchuda, the titular character of a supposedly nonfiction piece published in 1855, “The Jew-Broker of Damascus,” loaned “large sums to the needy, at extravagant rates of interest. With an expression of candor and sympathy for those who were unfortunate,” the article explained, “it was notorious, that he ground the faces of the poor without mercy.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Echoing this was a passage in Edwin Freedley’s highly popular midcentury advice book for striving young professionals, "), _c('em', [_vm._v("A Practical Treatise on Business.")]), _vm._v(" Freedley proposed a commercial taxonomy with itinerant peddlers at the bottom and eminent men engaged in international commerce at the top. Merchants, he declared, could be “reduced to one denomination—"), _c('em', [_vm._v("men who live by buying and selling.")]), _vm._v("” Moneylenders, however, inhabited a different category altogether, illustrated by the “Israelitish woman who sits behind a bench in her stall on the Rialto at Venice, changing gold into silver and copper, or loaning money to him who leaves hat, coat, and other "), _c('em', [_vm._v("collaterals,")]), _vm._v("” and the “Israelitish man who sits at Frankfort-on-the-Maine,” lending “millions to men who leave in pledge a mortgage on the States of the Church, on Austria, or Russia.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Unlike the moneylenders, who were identified by their religion and nationality, the “denomination” of merchants was defined solely by their entrepreneurial endeavors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No matter what their specific profession, all businessmen intended to make money. “The nation’s commerce is the merchant’s trade, the merchant’s trade is the farmer’s barter—the farmer’s barter is the jockey’s swap—the jockey’s swap is the usuer’s exchange—the usuer’s exchange is the foreigner’s wrap, and so on. . . . The grand object is "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONEY")]), _vm._v(",” according to the "), _c('em', [_vm._v("New England Artisan")]), _vm._v(" in 1833."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Even so, the tenacious double standard celebrated and honored the commercial exploits of “mainstream” wholesale and retail merchants while sharply criticizing "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("pawnbrokers’ business practices. Unlike pawnbrokers’ gains, which allegedly came from usury, wholesalers’ and retailers’ profits were considered reasonable, justified, and essential to the continued success of the nation. Pawnbroker Abraham Laban, a fictional character in an 1855 novel, explained the double standard to one of his customers: “The merchants denounce us for charging four per cent. a month for our money, when they design to realize eight per cent. on it, and sometimes succeed.” He continued, “With fifty thousand dollars, they sell to the amount of half-a-million. If they get ten per cent. profit on their sales, they receive eight per cent. per month on the capital invested. And yet they curse us, call us usurers, and pass laws to prevent us, if possible . . . from reaping more than six per cent. from "), _c('em', [_vm._v("our")]), _vm._v(" investments!”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presumably most businessmen were not inclined to detail their religious lives in their memoirs, since religion had no bearing on their economic success. Yet William Simpson, in his autobiography about life as a member of a prominent New York City pawnbroking family, took pains to correct any assumptions that his family was Jewish. The book’s very first pages boast that the Simpson family “set new and rigid ethical standards for a profession that has never been praised for its integrity or its charity.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Simpson’s book traced the family’s lineage from a long line of Englishmen who were “gentile” and “Protestant.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" The obituary of Robert Simpson, another member of the famous pawnbroking clan, described him as a former member of Trinity Church who had more recently attended Saint Andrew’s Protestant Episcopal Church. Yet an article from the 1860s on the Simpsons’ pawnshop presumed the proprietor’s ethnicity, describing him as a “Hebraic chief” overseeing a staff of “young Shylocks” and “Israelitish clerks.” The writer even gave Simpson the stereotypical German-Jewish dialect: “I gifs you only vifeen tollar on dat vatch.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Even gentile pawnbrokers were Jewish in the popular imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pawnbrokers were aliens in a commercial world populated by supposedly moral and upright Christian entrepreneurs, and the very nature of the business set it apart from “normal” economic dealings. The antithesis of merchants, pawnbrokers doled out money instead of taking it in, profiting from customers who lacked capital rather than possessed it. “His customers are not to be wheedled, coaxed, grinned at, protested to,” noted nineteenth-century writer Douglas Jerrold, who elaborated, “No; "), _c('em', [_vm._v("his")]), _vm._v(" customers—the people who contribute to him thirty per cent.—for the most part address him with a respectful meekness; many with a shame-faced hesitation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The ideal retail customer cared about fashion and purchased the latest goods to display status. Pawners, however, were “branded with the mark of necessity,” and therefore pawnbrokers could practice “the usual uncourteous behavior” with their customers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" To observers, pawnbroking "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("confounded the familiar relationship between customers and proprietors (or their surrogates, the clerks). Before the widespread appearance of fixed-price shops that charged everyone the same amount, customers negotiated what they would pay, and many factors determined an item’s ultimate cost. Although one could get a better price by paying cash, consumers more often bought goods on credit. One’s ability to obtain a line of store credit in turn depended on many things, including reputation and personal comportment—both considered accurate barometers of solvency. Flirting with the employees also helped with negotiations; conversely, difficult and overbearing customers who got on a clerk’s bad side received few favors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The purchases customers made in retail shops were optimistic in nature. They were also embodiments of their labor, the tangible rewards earned from an honest day’s work. Fabric might become a suit of clothes. Food would be prepared for a nourishing meal. A trinket could become a status symbol and a keepsake to be handed down in the family. Inside pawnshops, by contrast, pawners dispossessed themselves of the things they had worked hard to own, an aberrant act when the marketplace privileged consumption. Items that were once indicators of hope, economic vitality, and physical comfort became, as collateral, markers of a downward fall, loss of prospects, alienation. Critics looking at the process from outside saw the antithesis of capitalism at work in both the pawns and pawning. A woman “presents a small trinket to the pawnbroker: how different the money-lender’s manner from the oppressive obsequiousness of the jeweller who, five years since, sold the locket to her!”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Authors of popular fiction amplified emerging anti-Semitic sentiment through their work, which reached broader audiences than did business literature. Pieces of fiction were serialized in the newspapers and in the magazines delivered to readers’ doorsteps and hawked on street corners; they were also published as cheap soft-bound volumes that crowded booksellers’ shelves and filled the packs of itinerant peddlers. As pawnshops became familiar fixtures in most American cities by the 1830s and 1840s, pawnbrokers became important stock characters in this popular fiction, figures onto which authors projected prevailing cultural anxieties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two related literary genres, the urban novel and the more factually based urban sketch, peeled back the veneer of respectability from modern American life, revealing the city’s gritty recesses for genteel readers’ prurient appetites. A successful series of urban sketches was written by George Foster, who spent his career primarily as a newspaper reporter and wrote for such publications as the "), _c('em', [_vm._v("New York Tribune")]), _vm._v(" and the "), _c('em', [_vm._v("Philadelphia Sun.")]), _vm._v(" His books (“a curious mixture of indictment and celebration”), "), _c('em', [_vm._v("New York in Slices")]), _vm._v(" (1849), "), _c('em', [_vm._v("New York by Gas-Light")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("(1850), and "), _c('em', [_vm._v("New York Naked")]), _vm._v(" (ca. 1854), were devoted to the greatest American city."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" In "), _c('em', [_vm._v("New York in Slices")]), _vm._v(" the author both cautioned and promised his readers that life in the Five Points area would shock even “the practised eyes and hardened olfactories of a veteran New-Yorker.” He described the area as “the great central ulcer of wretchedness—the very rotting Skeleton of Civilization, whence emanates an inexhaustible pestilence that spreads its poisonous influence through every vein and artery of the whole social system, and supplies every heart-throb of metropolitan life with a pulse of despair.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The city’s collective despair in fact captivated American novelists and their readers alike. Urban America supplied plenty of material—anguish, poverty, crime—that rivaled Dickens’s London. New York City, for one, was “illuminated by a sickly lamp, while the street begins to fill with rowdies, negroes, drunken sailors, pick-pockets, burglars, and vagabonds of every description . . . [and] an intolerable stench of brandy, tobacco, and steaming carcasses, meets us.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" The squalor of the American metropolis was now on par with that of major European cities and proof of the country’s maturation. Foster and his peers celebrated the city as they inventoried its many indignities, obscenities, and depravities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seedy business establishments, characters in their own right, filled the pages of popular fiction and included such gray market enterprises as mock auction houses, gambling dens, oyster saloons, and gin shops. Pawnshops also frequently appeared. In a typical passage from "), _c('em', [_vm._v("New York in Slices,")]), _vm._v(" Foster wrote, “We don’t know a much more melancholy thing than to ramble through one of the extensive pawnbroking establishments in Chatham-street or the Bowery, crammed with their inconceivable variety of articles of use and luxury. . . . each group tell[s] its own little domestic or personal romance.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" From the frying pans and diamond rings he spotted in pawnshop windows Foster distilled tales of poverty and woe, adultery and debt. The pawnshop’s evocative contents, including andirons and wicker baskets, constituted a digest of mid-nineteenth-century markers of financial success turned to failure."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" He invited his comfortably middle-class readers to imagine the paths of ruin and degradation that led owners, clutching their possessions, through the pawnshop’s doors. Similarly, the pawnshop in the anonymous 1855 novel "), _c('em', [_vm._v("Estelle Grant")]), _vm._v(" is “literally crammed with parcels each one of which contains a lamentable history of its own.” The biography of a pawn was limited only by one’s imagination and could have been “the rich dress of the flaunting frail one,” “the starving mechanic’s toolbox,” “the failing courtezan’s jewels,” or “the unfortunate drunkard’s last shirt.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pawnshops especially captivated readers whose lives, economically and geographically, were far removed from the teeming masses that comprised the pawners in most antebellum East Coast cities. Author and poet Eliza Cook’s article "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("“Obscure City Life,” for example, appeared in an 1852 issue of the Cincinnati woman’s magazine the "), _c('em', [_vm._v("Ladies’ Repository.")]), _vm._v(" Edited by Methodist ministers and reaching a circulation of 40,000, the magazine was intended to offer midwestern readers a “less worldly” alternative to "), _c('em', [_vm._v("Godey’s Lady’s Book,")]), _vm._v(" containing “sober, earnest,” moral pieces of poetry and prose."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Although purportedly less cosmopolitan than "), _c('em', [_vm._v("Godey’s")]), _vm._v(" and other similar publications, the "), _c('em', [_vm._v("Repository")]), _vm._v(" did not shy away from bringing tales of big city life westward for its readers’ vicarious experience. Descriptions of the “lowly denizens” lurking in the city’s “back streets” constituted armchair slumming for nineteenth-century readers living hundreds of miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eliza Cook offered observations from peering into a family’s front window, revealing intimate scenes of urban life to thousands of avid readers. Acting as omniscient observer, Cook savored the “squalid and gloomy” lives of the people she saw and told of a “sickening display of varied poverty [that] exists in every thing there exhibited.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" An essential stop on Cook’s tawdry city tour was the pawnshop, infused with “desperate despair” and “sullen depravity.” Each pawn, she insisted, embodied a tragic story. From her perspective, nothing was pawned by choice, and all pawners lacked agency. Who could help seeing herself in the pawned tea service that “could tell a tale of ‘better days,’ when decent friends met on a birthnight, and when the plum-cake garnished the blue and gold plate”? One moment the family is enjoying “shrimp and water-cresses” served on fine Staffordshire decorated with “fairy birds and Eden flowers.” The next, the father has fallen ill and lost his job. The mother pawns a succession of prized possessions: the tea service, a sable gown, a ring. Pawns from another household fall victim to a son’s errant ways. Having “become a dissolute idler, and step by step declined into the abyss of vice,” he has pawned an inscribed Bible and a monogrammed silk handkerchief, both gifts from his mother."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Cook’s lesson to readers was clear. Rather than being an integral part of a family’s domestic economy—something they relied on to get them through the week—pawnshop transactions were part of a downward spiral leading ultimately to despair and death. In these accounts, neither pawns nor their owners were redeemed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pawnbrokers oversaw these dismal places, and the evil pawnbroker, almost always Jewish, appeared as a stock character in many popular novels. The short story “Cousin Fanny” appearing in "), _c('em', [_vm._v("Graham’s Magazine")]), _vm._v(" in 1849 is one example. Having pawned everything else, Cousin Fanny had only her most precious possessions left—two masterfully hand-painted miniature portraits of her father and mother. She had forfeited the gold locket that encased them long ago but hoped to get something for the pictures, which were “worth at least one hundred dollars each, and infinitely precious to her.” But the pawnbroker, a “hard, money-getting "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("son of Israel,” was inured to his customers’ suffering. Seeing indigence day in and day out—“having look[ed] on misery three hundred and thirteen times in the year”—made the man callous and unfeeling. Predictably, he declared Fanny’s precious miniatures to be worthless and wished her away. Only when she coughed up blood (which might stain the shop floor) did the pawnbroker reappraise the items, lending her four dollars on the portraits he knew to be “of much value” but a risky investment nonetheless: “Yes, pawnbroker and Jew that he was, he pitied her.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Authors frequently characterized pawnbroking as a profession well suited to the Jews, for whom, according to the common stereotype, such distasteful work seemed fitting. “Most of the pawnbrokers are foreigners,” observed one newspaper article, “chiefly Jews.” “The fact that but few native American citizens are willing to engage in such a calling, is honorable to the character of our countrymen.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Commentators set up Jewish pawnbrokers as straw men: depicting them as bloodthirsty and rapacious profiteers made capitalists such as bankers, dry goods merchants, and retailers seem perfectly moral and reasonable. They did not have to justify their own financial pursuits—not being Jewish was defense enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Authors and publishers realized that the American audience wanted to read about lurid subjects; and with the explosion of book publishing and the increasing presence of pawnshops in the urban landscape, popular fiction more often featured pawnbrokers and pawnshops. Capitalizing on the sensational nature of the business in order to sell more copies, the promotional material for the 1849 fictional work "), _c('em', [_vm._v("The Three Golden Balls, or The Diary of a Pawnbroker,")]), _vm._v(" provides a case in point:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THIS WORK")]), _vm._v(" presents a glowing picture of that epitome of human suffering and misery—the pawnbroker’s office! What a view of life it unfolds! Crime, dissipation, folly, and too often unmerited destitution, meet at the pawnbroker’s counter. The high and the low, the virtuous and the depraved, are alike the subjects of the cold, heartless, cent per cent usurer; who weighs with equal indifference the cherished token of affection which want wrings from the reluctant hand of suffering virtue, and the ill-got prize which successful villainy presents, and doles out his ducats with miserly hesitancy! Such are the scenes which, with the hand of a master, are portrayed here; and we venture the assertion, that it will be found a work of deep and intense interest."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The advertisement appeared in diverse publications including "), _c('em', [_vm._v("Godey’s Lady’s Book—the")]), _vm._v(" mainstream periodical for well-heeled women, and the "), _c('em', [_vm._v("Monthly Cosmopolite,")]), _vm._v(" one of the many New York City rags published for the “sporting” "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("crowd (young men who dedicated their leisure time to gambling, womanizing, and carousing). One version of the ad featured an illustration of the pawnbroker sitting behind his counter, scales at the ready, facing a downtrodden woman ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.1"
    }
  }, [_vm._v("fig. 2.1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.2"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0034-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.2.")])]), _vm._v(" Advertisement for "), _c('em', [_vm._v("The Three Golden Balls, or The Diary of a Pawnbroker, Monthly Cosmopolite")]), _vm._v(" 4, 13 (April 1, 1850). Courtesy, American Antiquarian Society.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.1"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0034-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.1.")])]), _vm._v(" Frontispiece, "), _c('em', [_vm._v("The Three Golden Balls, or The Diary of a Pawnbroker")]), _vm._v(" (New York: H. Long and Brother, 1849). Rare Book and Manuscript Library, University of Pennsylvania.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The promotional blurb, however, sensationally misrepresented the book’s content, which was actually a collection of dull, unrelated anecdotes. And the narrator was not even a pawnbroker by trade but a lawyer who had inherited the business from his father (himself a lawyer who had acquired the shop from a client as payment). The book’s frontispiece, titled “The Pawnbroker at Home”—shows an upstanding businessman with all the trappings of the genteel: he sits in his study, quill pen in hand, surrounded by book-lined shelves and a marble bust ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.2"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v(")—a far cry from the advertisement showing a curly-haired, hook-nosed man behind a counter. Clearly, publishers recognized that the reading public would be grabbed by the promise of lurid content about Jewish pawnbrokers exploiting vulnerable women (and getting their just deserts in the end).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('em', [_vm._v("The Three Golden Balls")]), _vm._v(" had nothing on Emerson Bennett’s "), _c('em', [_vm._v("The Artist’s Bride, or Pawnbroker’s Heir")]), _vm._v(" of 1856, which contained one of the most virulently anti-Semitic portrayals of a pawnbroker to date and fortified it with the popular scientific systems of physiognomy and phrenology. This was no minor work—Bennett was an extremely popular and prolific novelist who wrote more than fifty novels and serialized works in addition to hundreds of short stories during his career."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Now almost forgotten, Bennett enjoyed a loyal readership throughout his life; his most popular works, such as the frontier tale "), _c('em', [_vm._v("The Prairie Flower")]), _vm._v(" (1849), sold over 100,000 copies and were reprinted in several editions. Although one historian described Bennett’s productions as filled with “pasteboard heroes and heroines and occasionally interesting minor characters [who] go through melodramatic routines against an authentic backdrop,” nineteenth-century readers adored his writing."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like his other novels, Bennett’s "), _c('em', [_vm._v("Artist’s Bride")]), _vm._v(" appeared in many forms and saw a wide readership. It was serialized in the Philadelphia newspaper the "), _c('em', [_vm._v("Sunday Mercury")]), _vm._v(" in 1856 and published as a novel in New York that same year, with a subsequent edition coming out three years later. Bennett’s main character, ninety-five-year-old pawnbroker Isaac Jacobs, “had the same parentage” as his shop. With a “long, cadaverous, and wrinkled face,” “bloodless lips,” and “great, green, cold, goggle eyes that seemed to see dollars in everything,” Jacobs was “the personification of Avarice.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" The intensity of his drive for money was matched only by his deep hatred of Christians. The main story line revolves around Jacobs’s lifelong pursuit, “his monomaniac idea of revenge,” to obliterate every family member descended from his sister Hagar, because she married a Christian."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" By the end of the story, four people were dead on Jacobs’s orders, and heroine Villeta Linden, the last of Hagar’s descendants, had been abducted by Jacobs’s criminal partner, a man whose father had murdered her father at the pawnbroker’ behest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bennett’s pawnbroker is utterly corrupt and hateful. Had his plans come to fruition, “the Jew would have the treble satisfaction of getting one more of his hated relatives out of the way—of seeing the family of the murdered man crushed and blasted by sorrow and disgrace—and of having the family of the murderer more directly in his power.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Jacobs’s Jewish radicalism drove his homicidal tendencies. He was rabidly intolerant, going so far as to kill his own family members because they were products of intermarriage. Being a Jew, he was also impelled to kill out of greed, pure and simple. When authorities came to arrest Jacobs they found him “counting his money and congratulating himself.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Overcome with shock and fear, he died just as the police crashed through his door. The pawnbroker’s antithesis, Villeta Linden, the Christian “dove,” inherited all Jacobs’s money and lived happily ever after by helping the poor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("A reviewer in "), _c('em', [_vm._v("Godey’s Lady’s Book")]), _vm._v(" acknowledged that Bennett’s pawnbroker “is perhaps too strongly drawn” and that the “baseness” of his character “might probably have been applied with as much justice to brokers of other religious denominations, as to a professor of Judaism.” The reviewer continued, “We do not, we confess, approve of the practice adhered to by many of our popular writers, of choosing their characters from sects of religion or sections of country and, after making them as odious as possible, leaving them to be viewed as fair representatives of classes or bodies of men.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Yet the magazine continued to carry advertisements for Bennett’s new book, undoubtedly because copies continued to sell in great numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By midcentury works of popular culture, especially those depicting pawnbrokers, had fairly well established anti-Semitic stereotypes in the public mind. The presumed Jewish identity of pawnbrokers had become so accepted, in fact, that even fictional characters remarked on it. Charles Parkinson, featured in a novel about the Panic of 1857, was pleasantly surprised when, venturing into a pawnshop for the first time, he saw that “behind the counter stood not a black-eyed, long-bearded, sharp-visaged Jew, "), _c('em', [_vm._v("as my imagination had pictured,")]), _vm._v(" but an intelligent, business-like looking individual.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" The “Jew broker” embodied an extreme form of capitalism whose purpose was the worship of money above everything else, including God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These figures appeared again and again. Solomon Moses Simpson, the main character in "), _c('em', [_vm._v("Our Chatham Street Uncle,")]), _vm._v(" is caretaker for his niece Naomi, the product of a mixed marriage of Christian father and Jewish mother. Her religion is a constant source of tension in the Simpson household. Pure and principled, Naomi lectures the family about their lack of faith and their greediness. She tries to convert her cousin Hagar to Christianity, and the young girl asks, “But the Jews refuse Christ, and you say we can only get to heaven through him. Will there be no Jews in heaven, Naomi?” “Yes, indeed,” she replies, “God will give them a better mind.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" A true Christian, she is surrounded by the corrupting, materialistic forces of Judaism. Uncle Solomon admits, “I cares only for piles monish.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Naomi snaps at her cousin, “Don’t talk to me about Jews and Gentiles. You all worship money; and it makes you hard as iron.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" No matter that Simpson was a religious man who “kept the feasts, sent his family to synagogue, lived on good terms with his rabbi, [and] sometimes thought the holy city would be restored,” he nevertheless “worshipped ‘piles monish’ with all his soul.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" In the end Solomon Moses Simpson met the hellish fate that was coming to him—his shop went up in flames, the “stealthy foe” with “a little darting angry tongue like a serpent enraged . . . hissing for a troop of brother-demons.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The fire destroyed pawnbroker and pawnshop both. Even on the verge of death Simpson "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("continued to fret about “mein shops” and “mein monish,” and “With the name of his idol, mammon, on his lips, our uncle ventured into eternity.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en61"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nineteenth-century stories reinforced the prevailing notion that pawn brokers, and not the society they lived and worked in, conspired to create and profit from profound economic disparities and social isolation that Americans often faced. Just as urban areas were characters in these works, so too were the pawnshops themselves. Repositories of tens of thousands of personal objects no longer in their owners’ possession, pawnshops symbolized the tenuous and severed links between the present and past, the new country and the old, deep personal relationships and an impersonal world. Sometimes authors gave objects the power to reunite long-lost relatives, a trope that appeared throughout the century. In the 1843 "), _c('em', [_vm._v("Godey’s")]), _vm._v(" story “The Mourning Ring,” for example, a ring passes through the hands of several people before reaching the pawnshop. It belongs to an old woman whose granddaughter, an impoverished seamstress, takes it to a jeweler for repair. She loses it on an omnibus. A good Samaritan finds it and returns it to the wrong person, thinking it belongs to a wealthy passenger. The rich woman’s servant steals it from her and eventually pawns it. The poor seamstress’s father—the only survivor of a shipwreck but for years presumed dead—recognizes the ring when he happens to pass by the pawnshop. He makes inquiries and eventually finds his way back to his mother and daughter. The object, a shared possession, embodied the protagonists’ common lineage, linking them when all other lines of communication had failed. In its state as a piece of collateral, the ring symbolized alienation. Without the object to bring them together, the characters would have remained strangers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en62"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Similar stories appeared in other publications."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en63"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" The only thing that made them at all plausible was the pawnshop, which provided a reason for disparate objects and people to converge. The lost-and-found structure of these stories enabled authors to introduce characters who were members of the noble poor—hardworking children who were the only caretakers of sick and elderly relatives and were trying to make their way in harsh circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Highly exaggerated depictions of pawnbrokers, pawners, and pawns articulated the growing anxieties of American life as immigration delivered more people to the country’s shores and transportation networks increased mobility. Cultural and economic concerns intensified as people wondered who these new people were and what role they were to play. Works of popular culture had largely succeeded in creating a coherent, seemingly logical stereotype: the pawn-broker had become implicitly the "), _c('em', [_vm._v("Jewish")]), _vm._v(" pawnbroker—the Jew broker—and as Jews and pawnbrokers became increasingly stigmatized, the stereotypes reinforced each other."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en64"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" People coming from small, cohesive towns as part of flows of transnational and internal migration soon joined thousands of others. Strangers "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("now living together as neighbors and housemates, the newly transplanted did not necessarily look alike, maintain similar habits and customs, or speak the same language. It was easy to blame these strangers for problems arising from substandard living conditions and insufficient wages. And Jewish pawnbrokers often found themselves convenient scapegoats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ideas promulgated through popular culture influenced people’s daily interactions and thus functioned as powerful social forces. For example, anti-Semitic stereotypes found their way into formal credit reports, which came into use in 1841 as a response to the widespread economic anxieties that lingered in the aftermath of the Panic of 1837, a crash bankrupting even the most prudent businessmen. Face-to-face intercourse and recommendations from friends and acquaintances no longer proved one’s creditworthiness. Credit reporters, members of a wholly new profession, took into account a person’s business "), _c('em', [_vm._v("and")]), _vm._v(" personal life when calculating how likely he was to repay a debt. Sobriety and marital status counted as much as capital and assets. Ethnicity and religion were also determining factors. In a Jewish businessman a credit reporter saw not a savvy entrepreneur but another incarnation of Shylock. He was tribalistic. Greedy. Ruthless. Coldhearted. Scheming. And these characteristics, based on credit reporters’ perceptions rather than their actual experiences, ran counter to the Jeffersonian ideal of the yeoman farmer-entrepreneur—the independent individual who by his own merits rises and succeeds, helping to solidify the economic foundation of the entire nation. Even when credit reporters deemed a Jewish enterprise sound by all objective measures, they qualified their analyses to fit preconceptions of “Jewish business,” which remained shady and suspect. A typical comment was, “He is a Jew and although in point of fact he may now be perfectly responsible, yet Jews have a wonderful faculty of becoming at almost any moment they choose entirely irresponsible.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en65"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Proper” business dealings of eminent merchants took place according to an established etiquette, discreetly behind the doors of banks and counting-houses, and among like-minded entrepreneurs. The moneymaking of Jews was different—unseemly, crass, public. Transactions occurred in the full light of day, often on the sidewalk and within the used clothing shop, auction house, and pawnshop. You could see, hear, and (some people claimed) even smell Jews. An auctioneer was, “generally speaking, a black, curly headed Jew, with a moustache on his lip or an imperial on his chin.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en66"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" So fully formed was the stereotype that Jewish dealers were even ascribed an odor: “We "), _c('em', [_vm._v("smell")]), _vm._v(" Limburger cheese, and "), _c('em', [_vm._v("feel")]), _vm._v(" on our arm the gentle pressure of the hand of Moses,” claimed one observer."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en67"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Similarly, the home of pawnbroker Solomon Moses Simpson in Julia McNair "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("Wright’s "), _c('em', [_vm._v("Our Chatham Street Uncle")]), _vm._v(" smelled “extensively of onions, mackerel, and fried mutton.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en68"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.3"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0039-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaptionb"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.3.")])]), _vm._v(" Jews at the opera as a row of noses. "), _c('em', [_vm._v("New York Picayune")]), _vm._v(" 7, 48 (November 15, 1856): 381. Courtesy, American Antiquarian Society.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Nineteenth-century American popular culture established and normalized the archetype of the Jew as “half-comic, half-hideous, with red wig and grotesque false nose,” drawing it more finely and precisely over time."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en69"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Oversized noses, massive hands, and fractured English differentiated Jews from “native” and presumably more refined Anglo-Americans whose looks and behavior were taken as the norm against which everyone else was measured. A newspaper article about the opening of an Italian opera in 1856, for example, showed Jews in attendance as a row of noses ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.3"
    }
  }, [_vm._v("fig. 2.3")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en70"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" In John Beauchamp Jones’s 1855 novel "), _c('em', [_vm._v("The Winkles, or The Merry Monomaniacs,")]), _vm._v(" son Walter Winkle takes his friend George Parke out slumming one night and decides it would be an amusing “lark” to visit the shop of Abraham Laban, the “Jew pawnbroker.” As Walter casually explains, it’s “for the fun of the thing. Great Nose knows me.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en71"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such sweeping stereotypes gained even more credence when promulgated using “scientific” methods. The systems of physiognomy and phrenology, purportedly objective ways of determining people’s character from their appearance, were widely accepted at the time. Marshaling what were believed to be concrete, readily observable data comforted those who remained anxious about a changing society and were searching for a reliable way to assess the strangers living in their midst. Physiognomy, conveniently, posited that one’s countenance could not help but express character traits. Once learned, the structure of facial features could be read like a text and their underlying meanings clearly understood. Myriad books, pamphlets, and public lectures disseminated information "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("about the systems across the country. Luminaries and murderers alike were the subjects of physiognomic and phrenologic analyses; many people accepted the theories as grounded in fact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It so happens that “acquisitiveness”—the desire to possess things—was the personality trait written on Jewish faces based on their prominent noses. In his "), _c('em', [_vm._v("Outlines of a New System of Physiognomy")]), _vm._v(" James Redfield asserted, “This faculty is indicated by the breadth of the nose just above the wing of the nostril. . . . The sign, if large, gives a broad arch, as we see in the face of the negro, and in that of the Jew.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en72"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Redfield confirmed his findings in another study that compared the physiognomy of animals and humans. Benjamin Franklin’s double chin was a sure sign of his thrift. According to Redfield: “"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("‘Poor Richard,’ who was remarkable alike for his economy and his economical sayings,” was like the cow, who was also “very full under the chin, and is careful to pick up every straw that is thrown out with the dirt.” Conversely, Jews were analogous to goats in both temperament and appearance. Noting that both goats and (Orthodox) Jews had beards, Redfield joked, “The profession of a barber finds no followers among the Jews. And yet the Jew is a notorious "), _c('em', [_vm._v("shave,")]), _vm._v(" or there is no truth in the common opinion.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en73"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Redfield asserted that the Jew “takes the whole or none; figuratively speaking, he ‘grinds the faces of the poor.’ This kind of business is very thoroughly done in a pawnbroker’s establishment, and the Jews are the people to do it.” He added, gratuitously, “The smell in a pawnbroker’s store is sickening; it nearly resembles what the Spaniards call "), _c('em', [_vm._v("aroma de bacallo”")]), _vm._v(" (the smell of dried codfish)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en74"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Admiring a painting of Shylock on exhibit at the Philadelphia Art Union in 1849, a writer for "), _c('em', [_vm._v("Godey’s Lady’s Book")]), _vm._v(" commented that the work successfully captured the “angry menaces” of the character: “The head of Shylock, with its enormous frontal developments, its broad base and perverted moral powers, is in fearful phrenological accordance with the character.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en75"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the later decades of the nineteenth century the accretion of words and images in popular culture had created a fully formed stereotype of the “Jew broker,” well in line with the solidification of capitalism. Other businessmen were not singled out by their ethnic and religious affiliations. The behavior of Jewish businessmen, however, was judged by a different standard, and their entrepreneurial spirit and drive to make a buck were almost always seen as exploitative, motivated by a desire for money above everything else. The economic exploits of other businessmen seemed downright beneficent by comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Authors of popular fiction, who were particularly effective at reinscribing these ideas, cast the Jew broker as hard-hearted, greedy, uncaring. (Emerson Bennett’s blisteringly anti-Semitic "), _c('em', [_vm._v("Artist’s Bride")]), _vm._v(" even found a favorable new audience and was republished in both 1874 and 1875 under the title "), _c('em', [_vm._v("Villeta Linden.")]), _vm._v(") "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Business literature and other so-called factual pieces also revitalized centuries-old depictions of the grasping Hebrew moneylender. And the racist pronouncements of the phrenologists and physiognomists provided even laymen with the “objective” indicators they needed to prove that one’s “acquisitive” drive was as plain as the noses on Jewish faces. Seen favorably, the goatlike stubbornness Redfield assigned to the Jew could also manifest itself as respect for tradition, objectivity, and dispassion. One phrenologist itemized these traits: “He is religious; he is fond of trade; he is thrifty; he is conscientious, in his way”—all laudable qualities for any businessman. But all praise was tempered and qualified when it came to the "), _c('em', [_vm._v("Jewish")]), _vm._v(" businessman, because “his ideas of right and wrong are based on the Law of Moses, and his justice does not always admit the modifying influences of mercy” that, implicitly, Christian merchants possessed."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en76"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caricatures of pawnbrokers and references to pawning appeared in many forms and were quickly assimilated into new media. People who did not read novels or consult manuals of business advice might see cartoons in newspapers; those who did not read newspapers might sing satirical verses printed on song-sheets; those who did not sing might be handed a comic trade card on the street. By the mid-nineteenth century pawning had become such a familiar act that publishers assumed audiences would understand more obscure references to the three balls. For example, a cartoon from the time simultaneously lampooned genteel women’s needlework and pawning, a curious juxtaposition. Published under the heading “Our Fashions and Fancy Work” was a pattern to make a pocket watch case that looked exactly like the countless white-on-black stitchery patterns found in women’s magazines. Once fabricated, the case was to be embroidered with a picture of the three balls and the rubric “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MONEY LENT")]), _vm._v(".” It was “appropriate as a present to a young gentleman” because his watch would likely wind up in hock, its “manifest destiny” ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.4"
    }
  }, [_vm._v("fig. 2.4")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en77"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("By this time audiences were being entertained by humorous squibs about a pawnbroker’s character and background. The comic monthly "), _c('em', [_vm._v("Nick-Nax for All Creation,")]), _vm._v(" for instance, published a long list of pawnbroking jokes. Several alluded to aspersions on the pawnbroker’s religious and moral beliefs that it was assumed readers would get:")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_vm._v("No dinners? None with him. It is Lent all the year round.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_vm._v("What does he not allow? He never allows you to pledge your word, your honor, your character, or your reputation—these being articles of no value in his estimation.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_vm._v("Is he a Christian? No; he cannot bear anything to be redeemed.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_vm._v("What is his store? The refuge of the robber with his gain—a place wherein "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("poverty is obliged to witness the moral sucking of its blood, without the means of stopping the leech that draws it."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en78"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.4"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0042-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.4.")])]), _vm._v(" “Our Fashions and Fancy Work,” "), _c('em', [_vm._v("Nick-Nax for All Creation")]), _vm._v(" 1, 7 (November 1856): 224. Courtesy, American Antiquarian Society.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Relatively straightforward representations of pawnbrokers and pawnshops referred to current events and, logically, to economic downturns. The cartoon “Love and Hard Times,” for example, appeared in 1858, the year after a devastating economic panic. It depicts a woeful Cupid about to pawn his bow, arrow, and quiver ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.5"
    }
  }, [_vm._v("fig. 2.5")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en79"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" And as a metaphor for the country’s dire economic straits in the aftermath of another crash came the 1874 cartoon appearing in "), _c('em', [_vm._v("Harper’s Weekly,")]), _vm._v("“The Tendency of the Times: A Lesson to Heads of Families.” Here Uncle Sam stands in tatters on the doorstep of Levi’s pawnshop, about to pawn his pocket watch ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.6"
    }
  }, [_vm._v("fig. 2.6")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en80"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Illustrated magazines published in the final decades of the nineteenth century returned to a focus on the Jewish aspect of pawnbroking and pushed the stereotype even further, refining the anti-Semitic portrayals of Jews appearing in popular print. Although by the 1880s the complexion of pawnbrokers had changed, especially as more Irish joined the profession, pawnbroking would always be a “Jewish” occupation in the public imagination."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en81"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" The steady appearance of graphic imagery after the Civil War fixed these and other ethnic stereotypes in the American mind’s eye. Germans were brute butchers, Irish women "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("semiliterate domestics, and African Americans slack-jawed loafers. Jews were scheming criminals who, it was claimed, “had little respect for Christian laws, property, [and] even life.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en82"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.5"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0043-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.5.")])]), _vm._v(" “Love and Hard Times,” "), _c('em', [_vm._v("Nick-Nax for All Creation")]), _vm._v(" 2, 10 (February 1858): 295. Courtesy, American Antiquarian Society.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0043-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaptionb"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.6.")])]), _vm._v(" “The Tendency of the Times: A Lesson to Heads of Families,” "), _c('em', [_vm._v("Harper’s Weekly")]), _vm._v(" 18, 891 (January 24, 1874): 88. Library Company of Philadelphia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("The printed and moving pictures appearing in the visual landscape of the late nineteenth century provided the public with images that were much more complex and fully realized than textual descriptions. Pictures concretized popular stereotypes. What was more, graphic illustrations reached unprecedented numbers of the population and, unlike written texts, could speak to the literate and illiterate, native and nonnative speakers equally. They were highly influential in creating more definitive characterizations across ethnicity, religion, and occupation, normalizing the stereotypes among mass audiences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although it is impossible to know with certainty how faithfully individual consumers read and internalized the xenophobic messages put before them, caricatures in popular culture undoubtedly both shaped and reflected common attitudes. Some have argued that popular portrayals of Jews were benign compared with the treatment of members of other religious and ethnic groups. Even though Jews were shown as obsessed with making money, they were at least “sharper than other groups, who tended to be portrayed as dim witted.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en83"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" Yet “sharp” traders could as easily be considered scheming as smart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These distinctions were articulated and reinforced by popular media, which saw terrific expansion in the decades following the Civil War. More efficient papermaking and bookmaking technologies along with extended distribution networks brought greater numbers of affordable books, newspapers, and periodicals—now highly illustrated—to an audience growing adept at reading words and images. Publishing houses also printed works in foreign languages to accommodate the aesthetic tastes and practical needs of new immigrants. Cheaply produced broadsides, circulars, trade cards, songsheets, and other printed ephemera also circulated widely. Perhaps most effectively, illustrated humor magazines such as "), _c('em', [_vm._v("Puck")]), _vm._v(" and "), _c('em', [_vm._v("Judge")]), _vm._v(" deployed visual imagery to unapologetically critique all aspects of American life, from fads to political scandals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Puck")]), _vm._v(" was founded in 1877 (first published in both English and German), and by the 1890s nearly 90,000 people were reading the magazine, making it one of the most popular purveyors of comic images. And at the dawn of the twentieth century "), _c('em', [_vm._v("Judge’s Library")]), _vm._v(" was reaching over 114,000 people."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en84"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Tellingly, "), _c('em', [_vm._v("Puck")]), _vm._v(" “did not regard itself, nor was it thought of in its time,” as anti-Semitic; similarly, "), _c('em', [_vm._v("Judge")]), _vm._v(" represented itself as “scrupulous” and operating “within the bounds of modesty and good taste.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en85"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" If that was truly the case, then Jewish stereotypes had become fully normalized, accepted, and acceptable. Take, for instance, the cartoon appearing in an 1888 issue of "), _c('em', [_vm._v("Puck")]), _vm._v(" captioned “At Miss Ahrenheim’s Wedding.” "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("The father of the bride prods his daughter to test the purity of her wedding ring in the middle of the ceremony. In broken English he whispers, “Here ish der acid, Leah. Drop a liddle on der ring to see uf it vas reel golt!” Wearing an ill-fitting suit and an oversized diamond ring, Ahrenheim is associated with ostentatious yet shabby display (suggesting he is either a used clothing dealer or an unscrupulous pawnbroker who puts his customers’ collateral to personal use). Another "), _c('em', [_vm._v("Puck")]), _vm._v(" cartoon presents a baby’s “Alarming Symptoms.” Mother Cohnstein is concerned because her child lazes in its cradle all day “and don’t dake no interest in anyding.” Shocked, Father Cohnstein replies, “Vat! don’t dake no interest? Mine Gracious, he must be teadt!” In the house of another yet cartoon family, the Hockstein parents debate how best to discipline their son. Pawnbroker Hockstein says, “I vos going to put him on der gounter and make him vatch me vile I scharge der next gustomer only six per cent.” To which Mrs. Hockstein “"), _c('em', [_vm._v("in motherly horror")]), _vm._v("” protests, “Oh Fadder! You vos "), _c('em', [_vm._v("too")]), _vm._v(" cruel!” ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.7"
    }
  }, [_vm._v("fig. 2.7")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en86"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" All the cartoons utilize evocative surnames, broken English, and pictorial cues to present exaggerated depictions of Jews whose financial concerns take precedence over yet also define family bonds.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.7"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0045-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.7.")])]), _vm._v(" A Jewish father cruelly punishes his child by making him watch the pawnbroker charge less than legal interest. “A Case for Gerry,” "), _c('em', [_vm._v("Puck")]), _vm._v(" (January 18, 1893): 348. Library Company of Philadelphia.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("People bought illustrated magazines because of their “continuing popular fascination and delight with ethnic material.” Magazines continued to deliver this content and package it in different ways, such as putting out special issues focusing "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("on particular ethnic groups."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en87"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" The characters also lived on in other forms, migrating from the pages of "), _c('em', [_vm._v("Puck, Judge,")]), _vm._v(" and "), _c('em', [_vm._v("Life")]), _vm._v(" to appear on trade cards and in comic almanacs and popular joke books."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en88"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Eugene Zimmerman (better known as “Zim”), whose cartoons regularly appeared in print, discussed the importance of rendering physical characteristics in his 1910 book "), _c('em', [_vm._v("Cartoons and Caricatures, or Making the World Laugh.")]), _vm._v(" Hebrew and Irish faces displayed the “two extremes for characteristic curves.” “You already know,” he wrote, “that to produce an Irish face you must give it a pug nose, and the Hebrew face the hook nose.” While he acknowledged that not every face belonging to an ethnic group actually conformed to these characteristics, “to carry out the purpose of your picture you must stick to these” for broad audiences to comprehend the meaning."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en89"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" The results expressed the “split personality” of popular comics, whose contents could be at once good-humored and corrosive."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en90"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Defending itself against an attack by the "), _c('em', [_vm._v("Jewish Messenger")]), _vm._v(" over a particularly offensive cartoon in 1881, "), _c('em', [_vm._v("Puck")]), _vm._v("’s editor responded,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("We have no prejudice against the Jews or the Jewish religion, . . . no prejudice against the Irish or the Irish Roman Catholics; and if mere caricature is objectionable, the Irish have surely much more reason to complain than the Jews, who have always found a champion in "), _c('em', [_vm._v("Puck.")]), _vm._v(" Our Hebrew friends must not be so sensitive. . . . If they do not wish to be made fun of, they should not intensify the traditional peculiarities that so often make them the subject of ridicule. They are clannish, and cling to their antiquated puerile Oriental customs and mummeries as a Chinaman clings to his pigtail."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en91"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Jews should lighten up, "), _c('em', [_vm._v("Puck’")]), _vm._v("s editors insisted, because their magazine was an equal-opportunity offender; Jews, in fact, were treated generously compared with other ethnic groups. And if the cartoons "), _c('em', [_vm._v("did")]), _vm._v(" step over the line, it was only because Jews brought it on themselves by resisting assimilation, stubbornly clinging to their “traditional peculiarities.” In a contemporary essay Mark Twain defended the Jew thus: “He is not a loafer, he is not a sot, he is not noisy, he is not a brawler nor a rioter, he is not quarrelsome.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en92"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Yet he too equivocated, describing the group’s “other side.” The Jew, he wrote, “has a reputation for various small forms of cheating, and for practising oppressive usury, and for burning himself out to get the insurance.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en93"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" So as a group Jews were known to be industrious yet occupied themselves by pursuing petty gains at the expense of others. Commentators never clarified how this diverged from the exploits of other (Christian) capitalists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manufacturers of consumer products themselves disseminated anti-Semitic imagery through promotional materials, embellishing their packaging, circulars, "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("and trade cards with images of the Jew broker that were often printed in full color. Such advertising reached the masses—Americans could not avoid them. At Philadelphia’s 1876 Centennial Exposition, for example, exhibitors gave away tens of thousands of colorful trade cards and advertising circulars, igniting a national collecting craze that brought advertising into the home. Agents also sent trade cards through the mail, storekeepers piled them on shop counters, manufacturers sealed them inside packages, and leafleters distributed them on sidewalks. Adults and children avidly collected serialized trade cards and other small pieces of advertising—the “new” popular culture—and spent hours pasting them into scrapbooks."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en94"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Effective trade cards used novel images to capture people’s attention, and some advertisers incorporated the figure of the Jew broker into their promotional materials. One advertising card for a patent medicine produced in the late 1880s claimed that Taylor’s Sure Cure could calm even a pawnbroker’s guilty upset stomach and allow him to sleep through the night. We recognize him by his unfashionably long beard, ostentatious jewelry, and the prominent nose that supports his pince-nez. He sleeps soundly, dreaming of the “Bill of Goods” he sold that day. Each of the three gold balls carries part of the product’s name, and they are used as a convenient framing device to highlight Taylor’s Sure Cure ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.8"
    }
  }, [_vm._v("fig. 2.8")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pawnbroker appearing on the Bell’s Pond Lily Soap trade card was drawn using the same visual vocabulary, appearing with exaggerated facial features and large hands, outfitted vulgarly in a shabby jacket and ill-fitting trousers and sporting garish jewelry ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.9"
    }
  }, [_vm._v("fig. 2.9")]), _vm._v("). Here the meaning is even more evident. Personal hygiene, already a concern by the 1860s, had become an obsession of turn-of-the-century reformers. They believed that adopting the sanitary habits of “native” Americans was essential to immigrants’ assimilation, improving both their physical condition and their moral bearing. To the middle class especially, cleanliness functioned as an important visual cue marking “moral superiority,” while dirt was “a sign of degradation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en95"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" The message conveyed by the makers of Bell’s Soap was anything but subtle: their soap could purify even the vulgar Jew broker, exemplar of the “great masses of filth” invading the country."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en96"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Circulating the stereotype even further, including internationally, were postcards, wildly popular by the turn of the century. The U.S. Postal Service first issued prestamped postcards in 1873, and picture postcards gained popularity during the World’s Columbian Exposition in 1893. Postcards could be personalized and mailed all over the world. Americans sent more than 770 million in 1906 alone and well over 900 million in 1913."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en97"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" To meet consumer demand for novel cards, companies published countless designs. Any subject, from the patriotic to the pornographic, was commercially viable. Comic examples composed a large "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("part of the postcard market and included many examples satirizing pawnbrokers and pawnbroking drawn by some of the most famous comic illustrators of the era. Newspaper publisher William Randolph Hearst hired cartoonists to design comic postcards to be included as cutouts in the Sunday papers, commissioning among others Richard Felton Outcault (creator of Buster Brown), whose comic strips addressed social issues such as the hardships of tenement life."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en98"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Although the pawner is the butt of the joke in these postcard scenes, the pawnbroker remains his reliably stereotyped self ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.10"
    }
  }, [_vm._v("figs. 2.10")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.11"
    }
  }, [_vm._v("2.11")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0048-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.8.")])]), _vm._v(" Taylor’s Sure Cure is so good at treating indigestion that even a pawnbroker can sleep through the night. L. Crusius, illus., Richardson-Taylor Medicine Company (St. Louis, ca. 1888). Collection of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.9"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0048-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.9.")])]), _vm._v(" The stereotypical turn-of-the-century Jew has a large nose, lips, and hands and wears ill-fitting clothes and ostentatious jewelry. R. W. Bell Manufacturing Company (Buffalo: Gies, ca. 1890). Collection of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Stereotypical qualities, including those ascribed to the Jew broker, could not help but influence people’s thinking, given the sheer volume of printed material in circulation by the end of the century and the vividness of its content. Even representations meant to be innocuous used exaggeration, like the depiction of an avuncular Solomon Rubenstein on the cover of the 1894 “New Comic Song: Hock Shop”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en99"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.12"
    }
  }, [_vm._v("fig. 2.12")]), _vm._v("). Representations were often bizarre, such as another piece of sheet music, from 1909, titled “Big Chief Dynamite.” The song is about "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("a Jewish pawnbroker named Cohen who leaves his wife to go out West and become “a tough Jew Indian boy” who takes on “Tough Guy Levi” the “cowboy Jew.” On the cover, against a background of the iconic three balls, is a profile of Cohen as the “Jew Indian.” He has a grotesquely large nose and a curly beard, and on his lapel a diamond pin shines blindingly. On Cohen’s head sits, improbably, a full Indian headdress ("), _c('a', {
    attrs: {
      "href": "#/html/9780226905693_08_ch2#fig2.13"
    }
  }, [_vm._v("fig. 2.13")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en100"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Typically, though, the images were simply damning, such as the cover story recounting the crimes of “The Shylock Pawnbroker” that appeared in an 1895 issue of the pulpy "), _c('em', [_vm._v("Beadle’s Dime Library")]), _vm._v(" and showed a hunched, hook-nosed figure counting his lucre in a dark little garret."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en101"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.10"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0049-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.10.")])]), _vm._v(" “Say Au Revoir but Not Good Bye,” R. F. Outcault, illus. (New York: J. Ottmann, 1909). Collection of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.11"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0049-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.11.")])]), _vm._v(" “I’m Passing the Time” (New York: Souvenir Post Card Company, 1905). Collection of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "fig2.12"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0050-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.12.")])]), _vm._v(" Sheet music cover illustrating an avuncular pawn-broker. “A New Comic Song: Hock Shop” (Chicago: G. B. Brigham, 1894). The Lester S. Levy Collection of Sheet Music, Special Collections at the Sheridan Libraries, Johns Hopkins University.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "fig2.13"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0050-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaptionb"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURE 2.13.")])]), _vm._v(" Sheet music cover illustrating a Jewish cowboy. “Big Chief Dynamite” (Chicago: Will Rossiter, 1909). The Lester S. Levy Collection of Sheet Music, Special Collections at the Sheridan Libraries, Johns Hopkins University.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("By the close of the nineteenth century pawnbrokers and pawnshops, familiar fixtures in big cities and small towns alike, easily found a place in the movies. Full of possibility, pawnshops provided a rich setting for a host of theatrical situations, as they had in popular fiction. The first American film about pawnbroking, "), _c('em', [_vm._v("Love in a Broker’s Office,")]), _vm._v(" appeared in theaters in 1897. It was followed in the first decades of the twentieth century by "), _c('em', [_vm._v("Dress Suits in Pawn, A Jewel in Pawn, The Marriage Ring")]), _vm._v(" (also called "), _c('em', [_vm._v("The Pawn")]), _vm._v("), "), _c('em', [_vm._v("The Pawnbroker’s Daughter, The Pawnbroker’s Heart, Bill Tell Pawnbroker, She Loved Him Plenty,")]), _vm._v(" and Mutt and Jeff’s animated film from 1920, "), _c('em', [_vm._v("The Pawnbrokers.")]), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en102"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" Pawnshops were settings equally suited to comedies, dramas, and love stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A notable early film was the endearing 1916 comedy short "), _c('em', [_vm._v("The Pawnshop,")]), _vm._v(" a perfect showcase for Charlie Chaplin’s talents. As a hapless pawnbroker’s assistant, Chaplin dirties all the pawns in storage when he tries to dust, puts a customer’s head through a cello, guts a clock that a man has brought to hock, and nearly poisons a goldfish. In the end, Chaplin’s character foils a robbery attempt by a diamond broker courting the pawnbroker’s daughter. The hero of the day, at the end of the film he gets the girl. Much different in tone was the 1908 silent "), _c('em', [_vm._v("Old Isaacs, the Pawnbroker")]), _vm._v(" (written by D. W. Griffith), an unusually poignant portrayal of a Jewish character."), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en103"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" In the story, a little girl needs money for her sick and starving mother. The “Amalgamated Association of Charities,” which she approaches first, provides no assistance, so she turns to the pawnbroker. Isaacs’s assistant refuses to accept the girl’s worn shoes as collateral; when she returns with her doll, the pawnbroker himself deals with her and at once realizes her plight. Playing against type, he comes to the girl’s aid, saving her mother from eviction, paying their medical bills, and giving them food. He even buys the girl a new doll. In its promotional material Biograph described the film as “dissipating ‘the malignant calumnies launched at the Hebraic race.’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en104"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Correctives such as Biograph’s "), _c('em', [_vm._v("Old Isaacs")]), _vm._v(" were not unheard of, but only rarely did people consider that pawnbrokers were presented unfairly in popular culture. In one exceptional instance, a writer in the early 1870s explained to his readers that “a thriving pawnbroker should be a man with no excess of sensibility.” He continued, “So many stories of wretchedness, misfortune, and ghastly want must be poured into his ear, that if he were a tender-hearted man he would inevitably beggar himself every day.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en105"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Sentimentality never figured into people’s estimation of wholesalers, retailers, manufacturers, and other “established” men "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("of business. In fact, unlike pawnbrokers, who dealt with needy customers every day, they were often far removed from the daily exigencies of the working poor and therefore did not have to be mindful of their own “sensibilities.” Another contemporary newspaper article also addressed popular misconceptions about pawnbroking; it was titled “Pawnbrokers’ Clerks: Not So Unsympathetic and Heartless as They Seem.” The featured clerk denied that people in his profession were “fond of taunting the poor.” Pawnbroking was a business like any other. “Because we handle money and make loans,” he remarked, “people seem to think we loan it out because we don’t know what to do with it. This is a mistake. . . . I often get blue at seeing so much misery about me.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en106"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" Pawnbrokers could not indulge their emotions if they hoped to run a profitable business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet by the end of the century the few objective accounts of pawnbroking were no match for the deleterious words and images that over the century had created an indelible portrait of the Jew broker. The conflation of Jews and pawnbrokers in mass market forms distorted the public’s impression of pawnbroking, disseminating and naturalizing anti-Semitic stereotypes. The stereotypes in turn helped promulgate ideas about “proper” and “improper” ways to make money: demonized, Jew brokers made most other capitalists look good by comparison. “Queries regarding the Jews” no longer appeared in newspapers because by the dawn of the twentieth century the character of Jews, as presented in popular culture and represented most clearly by the pawnbroker, had become established beyond contestation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Purveyors of popular culture including publishers, marketers, and writers did end up making some concessions, realizing that they walked a fine line between lampooning and insulting patrons they were trying to attract. Having learned various trades, many Jews "), _c('em', [_vm._v("were")]), _vm._v(" economically successful and therefore enjoyed the power of the purse. Popular cartoonist E. C. Matthews, for instance, advised in his 1928 book "), _c('em', [_vm._v("How to Draw Funny Pictures,")]), _vm._v(" “Be careful not to offend the Jewish people in your cartoons, or you may be unable to get them published.” He underscored the admonition by describing an experience of cartoonist Zim, who “tells of a time when he bore down a little too heavily on these characters—and was called upon by a delegation of pawnbrokers, who asked him to desist.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ich2en107"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226905693_14_not#ch2en107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" That advertisers nevertheless saw fit to incorporate such caricatures in their promotional materials, however, shows just how normalized the types had become and how acceptable it was to deploy them in the mass media.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The image we conjure today of the exploitative, greedy, thieving pawnbroker became fully realized in the nineteenth century. Yet there remained a great discrepancy between common (mis)perceptions and the truth. Instead of equal opportunity for all, capitalism was created and fueled by large pools of "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("the working poor who constituted pawnbrokers’ main customer base. Rather than pulling them out of poverty as promised, hard work left many battling with their personal budgets. For average Americans, as we will see, upward mobility remained a mirage, forever unattainable. To blame pawnbroking, one of the clearest manifestations of capitalism’s inherent inequities, was much easier than taking on the economic system itself. The following chapters are devoted to presenting a more balanced view of pawnbroking in American history and to creating a more fully realized portrait of the Jew broker.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04abc53e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226905693_08_ch2.vue
// module id = 78
// module chunks = 0